import { useContext, useMemo } from 'react';

import { SessionStorageContext } from '../providers/SessionStorageContext';

/*
 *  Usage:
 *    const [value, setValue, removeValue] = useSessionStorage<T>(key: string);
 *
 *  Example:
 *    const [profile, setProfile, removeProfile] = useSessionStorage<Profile>("user");
 */
export const useSessionStorage = <T>(
  key: string,
): [T | null | undefined, (value: T | null) => void, () => void] => {
  const ctx = useContext(SessionStorageContext);
  if (!ctx) {
    throw new Error('Please configure SessionStorageContext before using "useSessionStorage()"');
  }
  const { setValue, removeValue } = ctx;
  return [
    ctx.state[key] as T,
    useMemo(() => setValue(key), [key, setValue]),
    useMemo(() => removeValue(key), [key, removeValue]),
  ];
};

export enum SESSION_KEY {
  CONFIGURATOR_SESSION = 'ConfiugratorPage_Session',
  CONFIGURATOR_PROJECT_CREATION = 'ConfiguratorPage_ProjectCreation',
  CONFIGURATOR_CONTACT_FORM_VALUES = 'ConfiguratorPage_ContactFormValues',
  CONFIGURATOR_PUBLIC_CONTACT_FORM_VALUES = 'ConfiguratorPage_PublicContactFormValues',
  CONFIGURATOR_LAST_SIDEBAR_VIEW = 'ConfiguratorPage_LastSidebarView',
}
